import get from 'lodash/get'

import {
  SET_CALENDAR_IS_LOADING,
  SET_CALENDAR_FILTER_LOADING,
  SET_CALENDAR_FILTER
} from '../actions/calendar-filters'

import {
  WORK_ORDERS_FOR_PERIOD_REQUEST,
  WORK_ORDERS_FOR_PERIOD_SUCCESS
} from '../actions/work-orders'

export default function (state = {}, action) {
  switch (action.type) {
    case WORK_ORDERS_FOR_PERIOD_SUCCESS: {
      const { year, month, workOrders } = action.payload
      return {
        ...state,
        [year]: {
          ...state[year],
          [month]: {
            workOrders: [ ...workOrders ],
            finishedLoading: true,
          }
        }
      }
    }

    case SET_CALENDAR_IS_LOADING: {
      const { year, month } = action.payload
      const workOrders = get(state, `${year}.${month}.workOrders`, [])

      return {
        ...state,
        [year]: {
          ...state[year],
          [month]: {
            workOrders,
            finishedLoading: false,
          }
        }
      }
    }

    case SET_CALENDAR_FILTER_LOADING: {
      const { isLoading } = action.payload

      return {
        ...state,
        isLoading,
      }
    }

    case SET_CALENDAR_FILTER: {
      return {
        ...state,
        ...action.payload,
      }
    }
  
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/calendar-filters.js